import { render, staticRenderFns } from "./AddEditProjectTask.vue?vue&type=template&id=3926ef16&scoped=true"
import script from "./AddEditProjectTask.vue?vue&type=script&lang=js"
export * from "./AddEditProjectTask.vue?vue&type=script&lang=js"
import style0 from "./AddEditProjectTask.vue?vue&type=style&index=0&id=3926ef16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3926ef16",
  null
  
)

export default component.exports